import { useEffect, useState } from "react";
import { Block, BlockHeader, BlockTitle, List, ListItem, Navbar, Page, Preloader, Table, TableBody, TableCell, TableHead, TableRow } from "konsta/react";
import TabBar from "../components/TabBar";
import { useAppContext } from "../context/AppContext";
import { useNavigate } from "react-router-dom";
import { FaArrowLeftLong } from "react-icons/fa6";
import { formatUSD } from "../utils";
import { useQuery } from "@tanstack/react-query";
import { fetchTransactions } from "../clients/ApiClient";
import { UserTransaction } from "../models/Models";
import { UserTransactionTypeCd } from "../enums";
import moment from "moment";

const TransactionsPage = () => {
    const {tgInitData} = useAppContext()
    const navigate = useNavigate()
    const [totalEarnings, setTotalEarnings] = useState(0)
    const [userTransactions, setUserTransactions] = useState<UserTransaction[]>()

    const { data: transactions, isLoading} = useQuery({
      queryKey: ["transactions"],
      queryFn: fetchTransactions,
      refetchInterval: 60 * (60 * 1000),
      enabled: tgInitData !== undefined
    });

    useEffect(() => {
      if (transactions) {
        setUserTransactions(transactions)
      }
    }, [transactions])

    return (
      <Page className="select-none pb-40">
        <Navbar
            title="Transactions"
            className="top-0 sticky translucent"
            left={<FaArrowLeftLong className="mx-3 w-5 h-5" onClick={() => navigate(-1)}/>}
          />

        {isLoading && <Block className="text-center">
          <Preloader />
        </Block>}

        {!isLoading && !userTransactions && <Block className="text-center">
          No transactions found!
        </Block>}

        {userTransactions && <>
          <div className="block overflow-x-auto mt-8">
            <div className="text-sm p-2">
              This page shows only the last 100 transactions.
            </div>

            <Table>
              <TableHead>
                <TableRow header>
                  <TableCell header>Type</TableCell>
                  <TableCell header className="text-right">
                    Amount
                  </TableCell>
                  <TableCell header className="text-right">
                    Date
                  </TableCell>
                  <TableCell header className="text-right">
                    Order #
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {userTransactions.map(t => {
                  let isPositive = false;
                  let type = '';
                  switch(t.type) {
                    case UserTransactionTypeCd.Deposit:
                      isPositive = false;
                      type = 'Purchase';
                      break;
                    case UserTransactionTypeCd.MarketplacePayout:
                      isPositive = true;
                      type = 'Marketplace Payout';
                      break;
                    case UserTransactionTypeCd.PurchaseUserProduct:
                      isPositive = false;
                      type = 'Marketplace Purchase';
                      break;
                    case UserTransactionTypeCd.Withdraw:
                      isPositive = true;
                      type = 'Withdraw';
                      break;
                  }
                  return <TableRow>
                  <TableCell>{t.type === UserTransactionTypeCd.Deposit ? 'Purchase' : t.type === UserTransactionTypeCd.MarketplacePayout ? 'Marketplace Payout' : t.type === UserTransactionTypeCd.PurchaseUserProduct ? 'Marketplace Purchase' :t.type === UserTransactionTypeCd.Withdraw ? 'Withdraw' : ''}</TableCell>
                  <TableCell className={`text-right ${isPositive ? 'text-primary' : 'text-red-500'}`}>{formatUSD(t.requestedAmount * (isPositive ? 1 : -1))}</TableCell>
                  <TableCell className="text-right">{moment.utc(t.createdAt).local().calendar()}</TableCell>
                  <TableCell className="text-right">{t.orderNumber}</TableCell>
                </TableRow>
              
              })}
              </TableBody>
            </Table>
          </div>
        </>}
        <TabBar selectedTab="profile"/>
      </Page>
    );
  };
  
  export default TransactionsPage;
  